/*
 *
 *. Input.jsx
 *
 */
//------------------------------------------------------------------------------
// External dep.
//------------------------------------------------------------------------------
import React from "react";
const classNames = require("classnames");

//------------------------------------------------------------------------------
// External dep.
//------------------------------------------------------------------------------
import logger from "../utils/LoggerFrontend";
//------------------------------------------------------------------------------
// Style
//------------------------------------------------------------------------------
export default class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isTyping: false };
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);

    logger.debug("Input:constructor", "called...");
  }
  componentWillUnmount() {
    //logger.debug("Input:componentWillUnmount", "called...");
  }

  handleUserInput(e) {
    if (this.props.deactivate) {
      return;
    }
    this.props.onChange(e.target.value);
  }

  handleFocus(e) {
    if (this.props.deactivate) {
      return;
    }

    this.setState({ isTyping: true });
  }

  handleBlur(e) {
    logger.debug("Input:handleBlur", "called...", this.props.autocomplete);
    this.setState({ isTyping: false });
    this.props.onBlur && this.props.onBlur();
  }

  render() {
    //logger.debug("Input:render", "called...");
    const {
      type,
      placeholder,
      autocomplete,
      exampleText,
      style,
      value = "",
      deactivate,
      showError
    } = this.props;

    const styleArr = classNames({
      input: true,
      "input--deactivate": deactivate,
      "error-input": showError
    });

    return (
      <div style={Object.assign({ position: "relative" }, style)}>
        <input
          className={styleArr}
          type={type ? type : "text"}
          placeholder={placeholder}
          onChange={this.handleUserInput}
          value={value}
          autoComplete={autocomplete || "on"}
          onClick={this.handleFocus}
          onBlur={this.handleBlur}
        />
        <span className="input__example input__example--small">
          {value.length < 1 ? exampleText : placeholder}
        </span>
      </div>
    );
  }
}
